var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 329,
    height: 418,
    viewBox: "0 0 329 418",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M56.6084 421L218.648 0.854302H292.145L130.105 421H56.6084ZM-122.214 421L39.8258 0.854302H113.322L-48.7173 421H-122.214ZM-165.617 322.04L-153.464 251.437H269.575L256.843 322.04H-165.617ZM-107.746 168.102L-95.5931 98.0781H328.025L315.872 168.102H-107.746Z",
    fill: "url(#paint0_linear_16246_97901)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16246_97901",
    x1: 303.302,
    y1: 223.5,
    x2: -176.434,
    y2: 223.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F00000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919199,
    stopColor: "#F00000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHash);
export default __webpack_public_path__ + "static/media/hash.c4b129ea066848b56c91b0d9fd5005fa.svg";
export { ForwardRef as ReactComponent };